import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';
import { Box, Typography } from '@material-ui/core';
import Popover from 'components/@common/Popover';

enum ChartSeriesKeys {
  Module_1 = 'Module 1',
  Module_2 = 'Module 2',
  Module_3 = 'Module 3',
  DATA_NOT_AVAILABLE = 'Data not available'
}

type Props = {
  module1Series?: number[];
  module2Series?: number[];
  module3Series?: number[];
  title: string;
  labels: string[];
  loading?: boolean;
  yAxisText?: string;
  onClick?: (index: number) => void;
  helpText?: string;
  series?: { name: string; data: number[] }[];
  colors?: string[];
  toolTipText?: string;
};

const ByQuestionModuleTypeChart: React.FC<Props> = ({
  module1Series,
  module2Series,
  module3Series,
  title,
  yAxisText,
  labels,
  onClick,
  helpText,
  series,
  toolTipText,
  colors = ['#338AC6', '#F6B247', '#84DCC6']
}) => {
  const { fullChartWidth } = useContext(PrintViewContext);

  const fallbackSeries: any = [
    {
      name: ChartSeriesKeys.Module_1,
      data: module1Series
    },
    {
      name: ChartSeriesKeys.Module_2,
      data: module2Series
    },
    {
      name: ChartSeriesKeys.Module_3,
      data: module3Series
    }
  ];

  return (
    <Box paddingBottom={2}>
      <Box marginBottom="24px">
        <Popover description={helpText}>
          <Typography style={{ fontSize: 24, fontWeight: 500 }}>{title}</Typography>
        </Popover>
      </Box>
      <BarChart
        height={250}
        width={fullChartWidth}
        onClick={onClick}
        series={series ?? fallbackSeries}
        options={{
          plotOptions: {
            bar: {
              columnWidth: '35%'
            }
          },
          colors: colors,
          yaxis: [
            {
              labels: {
                formatter: (value: any) => value
              },
              decimalsInFloat: 0,
              title: {
                offsetX: -2,
                text: yAxisText,
                style: {
                  color: '#373D3F',
                  fontSize: '12px',
                  fontWeight: 700,
                  fontFamily: 'futura-pt'
                }
              }
            }
          ],
          xaxis: {
            categories: labels,
            labels: {
              offsetY: -4,
              style: {
                colors: '#373D3F',
                fontSize: '10px',
                fontFamily: 'futura-pt'
              }
            },
            axisTicks: { show: false }
          },
          ...(toolTipText && {
            tooltip: {
              y: {
                title: {
                  formatter: (value: any) => {
                    return `${toolTipText}:`;
                  }
                }
              }
            }
          }),
          legend: {
            offsetY: 2,
            horizontalAlign: 'left'
          },

          dataLabels: { enabled: false }
        }}
      />
    </Box>
  );
};

export default React.memo(ByQuestionModuleTypeChart);
